import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500.000000 500.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M4725 9445 c-559 -89 -1028 -438 -1293 -963 -125 -246 -178 -446
-189 -708 -22 -513 188 -1011 565 -1341 77 -66 239 -183 256 -183 9 0 7 628
-2 632 -24 9 -143 174 -186 256 -97 190 -139 357 -139 562 0 244 60 449 190
653 267 420 758 632 1248 541 44 -8 89 -19 100 -24 11 -5 42 -16 69 -25 45
-14 244 -119 256 -134 3 -4 32 -29 64 -56 33 -28 71 -60 85 -73 13 -12 30 -21
37 -20 6 2 44 38 83 82 78 86 92 126 46 126 -15 0 -39 -7 -55 -15 -31 -16 -34
-13 -21 19 8 20 4 25 -43 79 -20 22 -34 27 -73 28 -39 1 -43 2 -23 9 14 4 42
8 62 9 30 1 40 7 55 31 9 17 21 30 25 30 5 0 6 10 3 23 -6 22 -4 23 42 21 51
-2 59 6 62 62 3 55 -187 178 -452 294 -73 32 -261 77 -369 89 -126 14 -302 12
-403 -4z"/>
<path d="M5968 9045 c3 -18 11 -25 26 -25 12 0 29 -6 36 -12 8 -7 -1 4 -19 25
-41 43 -50 46 -43 12z"/>
<path d="M4344 8616 c-107 -34 -183 -112 -204 -209 -8 -37 -10 -374 -8 -1182
l3 -1130 27 -47 c16 -25 46 -62 69 -82 78 -67 72 -66 679 -66 l546 0 65 26
c35 14 70 27 77 28 8 1 18 9 23 17 5 8 9 9 9 2 0 -6 29 8 64 31 36 25 81 46
105 50 22 3 41 11 41 16 0 6 62 10 162 10 89 0 159 2 157 5 -3 2 -146 5 -317
6 l-313 1 -43 -40 c-58 -53 -65 -54 -646 -50 -534 3 -508 0 -574 81 l-31 39 0
1147 0 1148 28 36 c47 62 92 78 204 75 l97 -3 8 -35 c18 -70 19 -70 318 -70
298 0 299 0 317 70 l9 35 111 0 c127 0 144 -7 198 -84 l30 -43 1 -461 c1 -254
2 -470 3 -479 1 -15 11 -18 61 -18 l61 0 -3 483 c-3 471 -3 483 -24 522 -31
57 -98 120 -163 152 l-56 28 -525 2 c-409 2 -534 -1 -566 -11z"/>
<path d="M5742 7738 l3 -253 346 0 c333 0 348 1 369 20 22 20 22 22 15 230 -6
207 -7 210 -31 233 -25 22 -27 22 -365 22 l-339 0 2 -252z"/>
<path d="M4791 7929 c-118 -23 -252 -88 -310 -150 -34 -37 -24 -79 19 -79 4 0
27 16 51 36 86 72 228 124 336 124 119 0 262 -51 334 -119 41 -38 65 -47 84
-31 28 23 15 49 -47 100 -122 98 -319 148 -467 119z"/>
<path d="M4760 7721 c-99 -32 -174 -91 -168 -133 5 -35 34 -33 92 7 129 89
303 87 417 -5 45 -36 63 -38 83 -8 15 20 14 24 -6 45 -91 97 -278 139 -418 94z"/>
<path d="M4806 7535 c-55 -19 -100 -66 -91 -94 8 -28 33 -27 91 4 62 33 113
32 175 -2 38 -22 53 -26 66 -17 26 16 26 29 -2 63 -46 53 -158 75 -239 46z"/>
<path d="M5479 7365 c-27 -8 -65 -33 -90 -57 -90 -87 -275 -300 -304 -351
l-30 -52 -3 -281 c-4 -311 0 -343 51 -401 66 -75 46 -73 662 -73 l550 0 50 25
c72 34 99 63 164 172 32 54 123 206 203 338 79 132 159 267 177 300 18 33 36
65 41 70 4 6 10 22 14 38 5 22 0 34 -34 71 -22 24 -40 49 -40 57 -1 15 -85 59
-112 59 -9 0 -18 -7 -22 -15 -8 -21 -23 -19 -31 4 -4 12 -12 17 -28 14 -13 -3
-30 4 -42 14 -63 59 -156 68 -795 78 -279 4 -343 2 -381 -10z m751 -171 c19
-11 45 -35 57 -54 23 -33 23 -37 23 -363 0 -378 -2 -388 -82 -440 l-42 -27
-422 0 c-419 0 -458 3 -490 35 -38 38 -44 79 -44 304 0 122 4 231 10 246 5 14
49 72 97 127 49 55 98 114 111 129 50 62 86 67 477 65 253 -1 272 -2 305 -22z"/>
<path d="M5630 7010 l0 -110 -139 0 c-110 0 -141 -3 -151 -15 -10 -13 7 -15
137 -17 l148 -3 3 -99 c2 -73 -1 -102 -10 -108 -7 -4 -77 -8 -156 -8 -131 0
-143 -1 -140 -17 3 -16 15 -18 124 -14 67 2 136 0 154 -4 l32 -7 -4 -104 c-3
-103 -3 -104 19 -104 22 0 23 3 24 108 1 59 -1 123 -2 142 -3 30 -4 70 -1 215
0 17 0 81 -1 143 -2 99 -4 112 -19 112 -16 0 -18 -12 -18 -110z"/>
<path d="M5908 7023 c2 -64 -1 -105 -9 -120 -10 -18 -10 -28 0 -47 9 -17 11
-51 7 -117 -3 -52 -5 -98 -6 -104 0 -5 1 -61 2 -122 1 -102 3 -113 20 -113 16
0 18 10 18 99 0 73 4 102 14 110 10 8 56 11 138 10 111 -1 123 0 123 16 0 16
-13 17 -125 16 -69 -1 -131 3 -138 7 -9 6 -12 35 -10 108 l3 99 138 3 c111 2
137 5 137 17 0 12 -26 15 -137 17 l-138 3 -3 108 c-2 93 -5 107 -20 107 -15 0
-17 -11 -14 -97z"/>
<path d="M4863 7349 c-46 -17 -59 -96 -21 -123 50 -35 118 -3 118 53 -1 49
-53 87 -97 70z"/>
<path d="M7067 7203 c-4 -3 -7 -24 -7 -45 l0 -38 56 0 c55 0 55 0 40 22 -9 12
-16 33 -16 45 0 19 -5 23 -33 23 -19 0 -37 -3 -40 -7z"/>
<path d="M6988 6890 c-69 -73 -86 -70 365 -70 456 0 498 3 517 34 11 18 11 19
-1 9 -15 -12 -62 -7 -54 7 2 4 -14 13 -37 19 -26 8 -37 16 -29 20 20 13 -164
21 -453 21 l-269 0 -39 -40z m845 -47 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17
0 24 -2 18 -5z"/>
<path d="M6838 6634 c-26 -14 -58 -60 -58 -84 0 -7 134 -10 423 -10 398 0 425
1 440 18 10 10 17 28 17 40 0 24 -15 30 -23 10 -3 -7 -6 -4 -6 8 -1 19 -8 21
-108 27 -58 4 -230 7 -382 7 -225 -1 -281 -4 -303 -16z"/>
<path d="M6669 6359 c-28 -10 -77 -86 -63 -97 5 -4 160 -5 344 -2 l334 5 16
27 c21 39 5 61 -51 70 -67 10 -550 8 -580 -3z"/>
<path d="M6258 6083 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M1540 5561 c-161 -52 -250 -215 -210 -382 46 -193 263 -290 451 -202
104 48 149 122 149 243 l0 70 -135 0 c-74 0 -138 1 -142 3 -5 1 -9 -22 -11
-50 l-3 -53 76 0 c82 0 93 -7 76 -52 -25 -66 -138 -97 -226 -63 -67 25 -115
98 -115 174 0 179 176 268 313 160 l37 -30 28 19 c15 11 36 30 47 42 l20 22
-35 30 c-67 57 -108 71 -205 75 -49 1 -101 -1 -115 -6z"/>
<path d="M2007 5564 c-4 -4 -7 -122 -7 -263 0 -280 5 -310 60 -339 23 -12 133
-13 145 -1 10 10 -12 94 -24 91 -6 -1 -21 2 -31 8 -19 10 -20 25 -22 258 l-3
247 -55 3 c-31 2 -59 0 -63 -4z"/>
<path d="M2767 5564 c-4 -4 -7 -142 -7 -306 l0 -298 60 0 c53 0 60 2 60 20 0
25 2 25 46 -5 43 -29 114 -34 167 -11 144 61 164 307 32 399 -59 40 -126 46
-187 14 l-47 -24 -3 106 -3 106 -55 3 c-31 2 -59 0 -63 -4z m257 -284 c71 -26
86 -139 27 -192 -96 -86 -220 37 -151 150 29 47 73 62 124 42z"/>
<path d="M3752 5289 l3 -281 33 -29 c28 -25 40 -29 90 -29 77 0 83 6 74 60 -6
37 -11 45 -27 43 -48 -6 -50 2 -51 239 -1 123 -2 235 -3 251 -1 26 -2 27 -61
27 l-61 0 3 -281z"/>
<path d="M5797 5564 c-4 -4 -7 -142 -7 -306 l0 -298 65 0 65 0 0 139 0 139 31
26 c32 27 40 29 77 20 41 -11 52 -51 52 -194 l0 -130 60 0 60 0 0 163 c0 191
-8 218 -80 255 -58 29 -108 28 -154 -3 -20 -14 -39 -25 -41 -25 -2 0 -6 48 -7
108 l-3 107 -55 3 c-31 2 -59 0 -63 -4z"/>
<path d="M8255 5553 c-89 -19 -137 -70 -143 -154 -7 -100 33 -141 192 -195 85
-29 96 -38 96 -80 0 -42 -30 -64 -88 -64 -44 0 -108 26 -131 54 -19 23 -25 21
-66 -21 l-36 -38 39 -35 c79 -71 203 -90 298 -46 68 31 97 74 102 147 7 100
-37 147 -178 190 -76 23 -120 54 -120 86 1 63 89 82 176 38 l49 -25 27 33 c33
38 33 39 9 61 -42 39 -158 64 -226 49z"/>
<path d="M9066 5529 c-3 -17 -6 -152 -6 -300 l0 -269 60 0 c58 0 60 1 60 27
l0 27 31 -30 c27 -26 37 -29 92 -29 80 1 126 30 159 99 29 62 32 183 6 231
-51 94 -133 127 -224 89 -22 -9 -42 -21 -46 -27 -13 -21 -16 -3 -20 103 l-3
105 -51 3 c-50 3 -51 2 -58 -29z m258 -250 c26 -12 56 -73 56 -112 -2 -78 -79
-133 -145 -102 -39 19 -55 51 -55 111 0 95 63 140 144 103z"/>
<path d="M6310 5255 l0 -297 148 4 c165 4 212 17 272 79 111 114 109 328 -2
432 -68 63 -94 70 -265 75 l-153 4 0 -297z m282 176 c62 -24 98 -88 98 -174 0
-119 -77 -190 -200 -185 l-65 3 -3 183 -2 182 74 0 c41 0 85 -4 98 -9z"/>
<path d="M4075 5506 c-39 -12 -40 -14 -43 -64 -3 -49 -4 -51 -35 -54 -31 -3
-32 -4 -32 -53 0 -49 1 -50 33 -53 l32 -3 0 -117 c0 -98 3 -122 20 -149 29
-48 71 -66 146 -61 35 2 66 7 69 10 4 3 3 27 0 52 -7 45 -8 46 -44 46 -61 0
-66 8 -69 119 l-4 100 34 6 c19 4 43 5 54 3 16 -3 19 4 22 49 l3 52 -53 3 -53
3 -3 63 c-3 69 -5 70 -77 48z"/>
<path d="M7408 5498 c-36 -9 -38 -12 -38 -48 0 -56 -8 -70 -41 -70 -28 0 -29
-2 -29 -45 0 -43 1 -45 30 -45 l30 0 0 -102 c0 -57 5 -119 10 -139 21 -75 83
-108 175 -95 43 7 45 9 45 41 0 52 -8 66 -36 59 -15 -4 -34 0 -49 10 -24 16
-25 21 -25 121 l0 105 50 0 50 0 0 45 0 45 -50 0 -50 0 0 65 c0 72 0 72 -72
53z"/>
<path d="M2400 5391 c-81 -26 -142 -85 -161 -153 -40 -150 67 -288 222 -288
96 0 170 44 211 123 17 34 20 54 16 118 -4 68 -8 81 -37 118 -18 23 -52 51
-74 62 -44 23 -137 33 -177 20z m139 -136 c22 -21 26 -35 26 -81 0 -50 -3 -58
-33 -85 -61 -54 -150 -30 -171 47 -16 57 13 123 64 145 32 14 87 2 114 -26z"/>
<path d="M3400 5391 c-38 -12 -85 -38 -100 -56 -11 -14 -9 -21 20 -50 l33 -34
28 21 c41 31 115 31 140 -1 38 -47 27 -56 -58 -53 -126 5 -193 -42 -195 -137
0 -50 27 -96 70 -117 44 -21 143 -15 170 9 23 21 42 22 42 2 0 -12 13 -15 56
-15 l55 0 -3 168 c-3 166 -3 169 -30 204 -43 56 -149 83 -228 59z m140 -276
c0 -40 -42 -75 -88 -75 -45 0 -62 14 -62 52 0 36 22 47 93 48 55 0 57 -1 57
-25z"/>
<path d="M4431 5373 c-70 -36 -108 -84 -123 -156 -30 -143 75 -267 227 -267
111 0 192 59 222 159 42 145 -54 276 -210 288 -54 4 -69 1 -116 -24z m182
-123 c61 -68 18 -190 -68 -190 -71 0 -114 41 -115 111 0 107 113 156 183 79z"/>
<path d="M5479 5391 c-150 -46 -213 -207 -133 -338 65 -107 228 -137 337 -61
15 11 32 28 37 38 9 17 4 24 -31 50 l-42 30 -29 -25 c-45 -38 -110 -35 -149 6
-24 26 -29 40 -29 83 0 45 4 56 31 82 40 38 105 41 142 6 l25 -24 40 26 c54
34 56 39 24 71 -54 55 -147 78 -223 56z"/>
<path d="M4833 5375 c-3 -9 -4 -84 -1 -168 4 -173 16 -207 78 -240 48 -25 135
-19 178 12 32 22 32 22 32 2 0 -19 6 -21 64 -21 l65 0 -2 213 -2 212 -62 3
-63 3 0 -131 c0 -170 -14 -200 -90 -200 -19 0 -36 9 -49 26 -19 24 -21 40 -21
165 l0 139 -60 0 c-45 0 -62 -4 -67 -15z"/>
<path d="M6967 5376 c-43 -16 -67 -33 -67 -50 0 -6 10 -24 23 -40 l23 -28 34
21 c69 42 150 20 150 -40 0 -23 -2 -24 -78 -24 -125 0 -182 -43 -182 -138 0
-106 130 -166 224 -102 44 30 46 30 46 5 0 -18 7 -20 56 -20 l56 0 -4 163 c-3
153 -5 166 -27 198 -42 62 -161 88 -254 55z m167 -234 c10 -16 -15 -82 -34
-92 -24 -13 -76 -13 -101 0 -22 12 -26 62 -6 78 24 20 131 30 141 14z"/>
<path d="M7725 5371 c-63 -28 -69 -42 -37 -80 l28 -33 34 21 c65 40 146 19
152 -39 3 -25 2 -25 -58 -22 -112 7 -182 -29 -203 -103 -13 -47 1 -94 40 -131
27 -26 37 -29 99 -29 57 0 72 4 92 23 30 27 38 28 38 2 0 -18 7 -20 55 -20
l55 0 0 133 c-1 199 -18 248 -102 281 -51 21 -143 19 -193 -3z m172 -229 c7
-4 10 -16 8 -27 -2 -11 -4 -23 -4 -27 -3 -21 -48 -48 -82 -48 -71 0 -97 69
-36 95 35 15 95 19 114 7z"/>
<path d="M8592 5218 c3 -141 6 -168 23 -197 24 -40 77 -71 122 -71 34 0 103
28 103 42 0 4 7 8 15 8 8 0 15 -9 15 -20 0 -18 7 -20 55 -20 l56 0 -1 210 -1
210 -54 0 c-39 0 -54 -4 -59 -16 -3 -9 -6 -71 -6 -138 0 -115 -1 -124 -23
-144 -15 -14 -36 -22 -60 -22 -50 0 -67 27 -67 106 0 33 -3 95 -6 137 l-7 77
-54 0 -55 0 4 -162z"/>
<path d="M3280 4560 l0 -110 43 -1 c95 -3 119 6 142 51 49 95 -14 170 -142
170 l-43 0 0 -110z m119 55 c33 -17 46 -56 30 -88 -16 -31 -28 -37 -71 -37
l-38 0 0 63 c0 35 3 67 7 70 11 11 42 8 72 -8z"/>
<path d="M3642 4643 c-6 -15 -24 -61 -41 -102 -17 -40 -31 -77 -31 -82 0 -17
39 -9 50 11 8 16 21 20 60 20 40 0 50 -4 55 -20 6 -20 45 -29 45 -10 0 5 -18
54 -39 107 -34 83 -43 98 -64 101 -19 2 -27 -3 -35 -25z m58 -100 c0 -7 -11
-13 -25 -13 -28 0 -30 4 -13 51 l12 34 12 -30 c7 -17 13 -36 14 -42z"/>
<path d="M3850 4650 c0 -16 6 -20 35 -20 l35 0 0 -90 c0 -83 1 -90 20 -90 19
0 20 7 20 90 l0 90 36 0 c28 0 35 3 32 18 -3 14 -17 17 -91 20 -82 3 -87 2
-87 -18z"/>
<path d="M4171 4648 c-5 -13 -25 -62 -44 -110 l-35 -88 23 0 c15 0 26 7 30 20
5 17 15 20 57 20 41 0 51 -3 55 -19 5 -21 40 -35 49 -19 6 9 -60 180 -79 206
-15 20 -47 14 -56 -10z m47 -73 c17 -37 15 -45 -11 -45 -33 0 -37 7 -24 41 14
36 20 36 35 4z"/>
<path d="M4570 4560 c0 -102 1 -110 20 -110 17 0 19 8 22 68 l3 67 27 -57 c36
-77 57 -78 89 -3 13 30 27 55 32 55 4 0 7 -29 7 -65 0 -59 2 -65 20 -65 20 0
21 5 18 108 -3 102 -4 107 -25 110 -19 3 -28 -8 -55 -62 -18 -36 -35 -66 -38
-66 -3 0 -21 29 -39 65 -26 54 -36 65 -56 65 l-25 0 0 -110z"/>
<path d="M5002 4653 c-5 -10 -27 -58 -47 -106 -27 -63 -35 -91 -27 -99 7 -7
18 -3 35 16 19 21 33 26 70 26 37 0 47 -4 52 -20 7 -22 45 -28 45 -7 0 6 -18
55 -39 107 -29 72 -44 96 -59 98 -12 2 -25 -4 -30 -15z m45 -85 c13 -30 9 -38
-24 -38 -26 0 -27 5 -12 49 12 34 18 32 36 -11z"/>
<path d="M5247 4663 c-4 -3 -7 -53 -7 -110 l0 -103 68 0 c48 0 73 5 88 18 66
53 58 149 -16 187 -29 15 -121 21 -133 8z m124 -52 c17 -13 23 -29 23 -56 0
-44 -22 -65 -71 -65 l-33 0 0 70 0 70 29 0 c16 0 39 -8 52 -19z"/>
<path d="M5557 4663 c-4 -3 -7 -53 -7 -110 l0 -103 81 0 c71 0 80 2 77 18 -3
18 -6 19 -68 21 -36 1 -40 4 -40 26 0 23 3 25 51 25 43 0 50 3 47 18 -2 13
-15 18 -51 20 -42 3 -47 5 -47 28 0 23 3 24 55 24 48 0 55 2 55 20 0 18 -7 20
-73 20 -41 0 -77 -3 -80 -7z"/>
<path d="M5992 4654 c-15 -10 -22 -25 -22 -49 0 -37 6 -43 65 -65 28 -11 40
-21 40 -35 0 -20 -13 -22 -84 -13 -39 5 -36 -21 5 -38 48 -20 99 -11 120 21
24 37 11 73 -34 91 -55 21 -67 30 -67 45 0 10 14 14 49 14 55 0 70 16 31 33
-36 16 -76 15 -103 -4z"/>
<path d="M6240 4561 c0 -84 3 -110 14 -114 8 -3 17 -3 20 0 3 4 6 55 6 115 0
101 -1 108 -20 108 -19 0 -20 -7 -20 -109z"/>
<path d="M6409 4668 c-1 -2 -3 -51 -6 -110 l-4 -108 25 0 c25 0 26 2 26 68 l1
67 30 -57 c16 -32 36 -58 44 -58 8 0 28 26 44 58 l30 57 1 -68 c0 -65 1 -68
23 -65 21 3 22 7 22 108 l0 105 -30 0 c-27 0 -31 -5 -54 -62 -13 -35 -28 -63
-33 -63 -5 0 -23 29 -39 65 -26 54 -35 65 -55 65 -13 0 -24 -1 -25 -2z"/>
<path d="M6770 4560 c0 -103 1 -110 20 -110 16 0 20 7 20 35 0 34 1 35 40 35
89 0 124 97 49 135 -15 8 -51 15 -79 15 l-50 0 0 -110z m115 35 c0 -27 -3 -30
-37 -33 -38 -3 -38 -3 -38 33 0 36 0 36 38 33 34 -3 37 -6 37 -33z"/>
<path d="M7050 4560 l0 -110 75 0 c58 0 75 3 75 14 0 18 -31 28 -73 24 l-32
-3 -3 93 c-2 84 -4 92 -22 92 -19 0 -20 -7 -20 -110z"/>
<path d="M7307 4664 c-4 -4 -7 -54 -7 -111 l0 -103 81 0 c71 0 80 2 77 18 -3
14 -14 17 -56 17 -41 0 -53 4 -58 17 -9 28 4 38 52 38 37 0 44 3 44 20 0 17
-7 20 -51 20 -47 0 -50 2 -47 23 3 19 10 22 61 25 49 3 58 6 55 20 -3 14 -17
18 -74 20 -38 1 -73 0 -77 -4z"/>
<path d="M2367 4562 c-563 -2 -598 -3 -595 -20 3 -16 41 -17 613 -17 554 0
610 1 613 16 2 9 -5 18 -15 20 -10 2 -287 3 -616 1z"/>
<path d="M7770 4546 c0 -8 5 -18 11 -22 6 -3 257 -2 557 2 301 5 526 10 499
12 -26 2 -45 7 -42 13 4 5 -189 9 -509 9 -443 0 -516 -2 -516 -14z"/>
<path d="M2185 4104 c-121 -32 -204 -109 -246 -231 -24 -70 -24 -115 -1 -191
36 -114 111 -193 215 -228 56 -19 -52 -19 1357 5 267 5 737 5 1045 1 821 -10
3471 -2 3630 12 155 13 122 13 276 -2 140 -13 182 -7 256 36 79 46 142 163
143 265 0 98 -22 158 -81 223 -103 112 -103 112 -707 99 -306 -7 -607 -8 -782
-3 -316 10 -5073 22 -5105 14z m321 -92 c54 -27 120 -101 133 -148 48 -172
-55 -328 -224 -342 -133 -10 -236 62 -269 191 -35 133 45 276 175 316 49 15
139 6 185 -17z m3075 13 c105 -36 172 -132 172 -245 0 -72 -16 -119 -58 -168
-50 -59 -102 -85 -180 -90 -88 -5 -157 21 -211 80 -48 54 -66 101 -67 173 -1
184 171 309 344 250z m-681 -255 c0 -107 -4 -170 -10 -170 -6 0 -10 63 -10
170 0 107 4 170 10 170 6 0 10 -63 10 -170z m2960 112 c0 -5 -8 -24 -17 -43
-23 -44 -23 -133 0 -178 11 -21 14 -38 8 -44 -26 -26 -63 47 -65 128 -1 72 26
145 56 145 10 0 18 -4 18 -8z m720 -34 c26 -58 26 -140 -1 -195 -19 -39 -37
-52 -51 -37 -4 3 2 24 13 47 23 51 24 115 4 164 -19 45 -19 63 0 63 9 0 25
-19 35 -42z m-5280 -30 l1 -63 23 26 c24 28 66 47 66 31 0 -5 -7 -15 -15 -22
-27 -23 -28 -49 -1 -85 31 -40 32 -45 7 -45 -11 0 -29 14 -41 30 -24 34 -40
31 -40 -6 0 -17 -5 -24 -20 -24 -19 0 -20 7 -20 110 0 103 1 110 20 110 18 0
20 -7 20 -62z m160 42 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20
20 13 0 20 -7 20 -20z m460 -42 l0 -62 34 33 c24 23 40 32 52 27 15 -6 14 -10
-10 -35 l-28 -29 31 -46 c32 -45 32 -46 9 -46 -14 0 -30 11 -43 30 -25 38 -34
38 -42 0 -4 -21 -11 -30 -22 -28 -13 3 -17 20 -19 97 -3 104 0 121 23 121 12
0 15 -13 15 -62z m3690 -27 c0 -50 5 -93 10 -96 17 -10 11 -35 -8 -35 -35 0
-42 21 -42 122 0 91 1 98 20 98 19 0 20 -7 20 -89z m78 67 c-2 -13 -10 -23
-18 -23 -8 0 -16 10 -18 23 -3 17 2 22 18 22 16 0 21 -5 18 -22z m360 -59 c4
-93 -1 -113 -33 -127 -45 -21 -91 -15 -114 14 -17 22 -21 41 -21 105 0 72 2
79 20 79 18 0 20 -7 20 -66 0 -77 12 -104 45 -104 33 0 45 27 45 103 0 35 3
67 7 71 18 18 28 -7 31 -75z m-5013 47 c31 -31 40 -69 29 -115 -11 -45 -58
-71 -126 -71 l-47 0 -3 101 c-2 55 -1 103 1 105 2 2 31 4 63 4 49 0 63 -4 83
-24z m2935 -49 c0 -78 9 -97 47 -97 31 0 43 28 43 104 0 59 2 66 20 66 18 0
20 -7 20 -80 0 -73 -3 -83 -25 -105 -28 -29 -88 -33 -120 -9 -17 12 -21 29
-23 104 -4 86 -3 90 17 90 19 0 21 -6 21 -73z m968 -15 l3 -82 44 0 c38 0 45
-3 45 -20 0 -18 -7 -20 -65 -20 l-65 0 0 106 c0 95 2 105 18 102 14 -3 17 -16
20 -86z m-3278 59 c0 -10 9 -21 20 -24 11 -3 20 -12 20 -21 0 -9 -8 -16 -20
-16 -17 0 -20 -7 -20 -39 0 -31 4 -41 20 -46 32 -10 25 -35 -10 -35 -35 0 -50
27 -50 86 0 19 -4 34 -10 34 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 9 10
20 0 13 7 20 20 20 13 0 20 -7 20 -19z m-467 -32 c32 -17 37 -28 37 -90 l0
-55 -57 -2 c-62 -2 -83 9 -83 42 0 31 19 46 56 46 38 0 52 15 27 29 -11 6 -24
6 -35 0 -19 -10 -38 -4 -38 12 0 10 35 27 58 28 7 1 23 -4 35 -10z m635 -5
c19 -13 22 -24 22 -78 l0 -63 -52 -1 c-58 -1 -78 10 -78 43 0 28 15 41 58 50
44 9 42 29 -3 22 -40 -7 -57 10 -30 30 25 17 55 17 83 -3z m238 8 c6 -4 14
-24 18 -44 9 -49 20 -48 35 2 16 54 43 54 61 0 15 -45 21 -44 35 8 6 21 18 38
28 40 22 4 21 -6 -3 -89 -16 -52 -25 -69 -39 -69 -18 0 -41 37 -41 65 0 30
-20 14 -30 -25 -8 -29 -16 -40 -29 -40 -15 0 -25 17 -44 74 -27 81 -25 101 9
78z m324 -12 c16 -16 20 -33 20 -79 l0 -60 -61 2 c-72 2 -91 18 -71 61 8 19
19 26 39 26 16 0 34 4 42 9 11 7 9 11 -8 21 -17 9 -26 9 -36 0 -15 -12 -35 -6
-35 11 0 12 37 28 68 28 12 1 31 -8 42 -19z m141 9 c28 -14 12 -32 -22 -25
-42 8 -38 -17 5 -32 42 -15 51 -37 31 -68 -17 -26 -61 -32 -96 -13 -29 15 -12
31 27 23 26 -5 34 -3 34 9 0 8 -11 18 -24 21 -26 6 -56 31 -56 47 0 17 40 49
61 49 11 0 29 -5 40 -11z m1677 5 c37 -10 24 -40 -16 -36 -39 4 -43 -13 -5
-23 16 -4 34 -11 40 -17 19 -16 15 -56 -6 -68 -26 -14 -74 -13 -89 2 -22 22
-12 30 28 23 51 -9 52 7 3 32 -46 22 -55 54 -21 77 25 18 32 19 66 10z m167
-4 c6 -2 18 0 29 5 27 12 69 -7 76 -33 3 -13 3 -45 2 -72 -3 -41 -7 -50 -22
-50 -16 0 -19 9 -22 58 -3 49 -6 57 -23 57 -17 0 -20 -8 -23 -57 -3 -49 -6
-58 -22 -58 -16 0 -19 9 -22 58 -3 49 -6 57 -23 57 -17 0 -20 -8 -23 -57 -3
-50 -6 -58 -22 -58 -18 0 -20 7 -20 79 l0 79 53 -3 c28 -1 57 -3 62 -5z m245
-10 c15 -15 20 -33 20 -79 l0 -59 -60 -1 c-54 0 -62 2 -71 23 -17 36 3 65 51
72 48 8 42 27 -8 22 -41 -4 -55 17 -20 31 37 15 67 12 88 -9z m162 3 c14 -12
18 -32 18 -80 0 -56 -2 -63 -20 -63 -18 0 -20 7 -20 55 0 40 -4 57 -15 61 -28
11 -45 -16 -45 -68 0 -42 -3 -49 -17 -46 -15 3 -19 16 -21 67 -2 35 -1 69 1
75 7 18 99 17 119 -1z m374 -4 c17 -19 27 -93 17 -125 -5 -14 -104 -16 -120
-2 -16 13 -17 50 -1 66 7 7 24 12 39 12 15 0 31 5 35 11 10 17 -17 29 -39 17
-29 -15 -49 9 -23 28 28 20 70 17 92 -7z m77 -19 c13 -51 25 -58 32 -17 7 37
30 65 43 53 4 -4 14 -26 23 -49 l17 -42 7 37 c8 42 30 67 45 52 7 -7 2 -35
-13 -80 -18 -53 -29 -70 -45 -72 -17 -3 -22 3 -28 32 -9 51 -19 52 -33 5 -10
-32 -16 -40 -33 -37 -15 2 -25 18 -39 63 -24 76 -24 97 -2 93 10 -2 21 -18 26
-38z m297 20 c15 -15 20 -33 20 -79 l0 -59 -53 -1 c-59 0 -72 5 -81 35 -8 27
15 53 55 61 16 3 29 9 29 14 0 12 -34 11 -46 -1 -8 -8 -15 -6 -25 6 -31 38 64
61 101 24z m158 -63 c3 -72 1 -77 -18 -77 -18 0 -20 6 -20 81 0 71 2 80 18 77
14 -3 17 -16 20 -81z m481 74 c23 -15 6 -39 -23 -34 -16 3 -26 1 -26 -6 0 -6
14 -14 30 -18 34 -6 51 -44 33 -72 -12 -19 -79 -27 -98 -11 -21 17 -8 42 15
30 10 -6 26 -10 34 -10 27 0 18 20 -14 32 -38 13 -55 41 -40 67 15 29 60 40
89 22z m161 -11 c11 -11 20 -33 20 -49 0 -27 -2 -28 -52 -30 -61 -1 -69 -6
-35 -22 19 -9 30 -9 40 -1 7 6 18 7 27 2 24 -15 -7 -40 -50 -40 -44 0 -68 23
-76 71 -11 68 78 117 126 69z m145 14 c20 -8 48 -62 41 -80 -4 -9 -22 -14 -56
-14 -27 0 -50 -4 -50 -9 0 -14 28 -21 60 -14 17 3 30 1 30 -4 0 -34 -85 -46
-112 -15 -59 68 4 167 87 136z m-5015 -79 c0 -68 -2 -75 -20 -75 -18 0 -20 7
-20 75 0 68 2 75 20 75 18 0 20 -7 20 -75z m125 10 c0 -5 -21 -11 -47 -13 -39
-3 -48 0 -48 13 0 13 9 16 48 13 26 -2 47 -7 47 -13z"/>
<path d="M2328 3911 c-15 -12 -32 -37 -38 -57 -11 -34 -10 -42 24 -108 20 -39
47 -84 60 -100 l23 -29 51 83 c62 100 68 146 27 194 -34 40 -107 48 -147 17z
m99 -50 c27 -26 20 -69 -14 -82 -36 -14 -73 12 -73 52 0 14 38 49 53 49 7 0
23 -9 34 -19z"/>
<path d="M5460 3923 c-34 -14 -50 -65 -34 -108 9 -23 62 -48 90 -41 25 7 54
52 54 86 0 46 -62 81 -110 63z"/>
<path d="M5402 3740 c-32 -20 -46 -63 -31 -92 8 -15 25 -18 115 -18 113 0 144
9 144 41 0 54 -53 92 -105 76 -22 -6 -43 -6 -63 1 -24 8 -35 7 -60 -8z"/>
<path d="M2930 3768 c0 -66 1 -68 26 -68 39 0 62 17 69 50 10 44 -14 77 -59
82 l-36 4 0 -68z"/>
<path d="M3137 3723 c-15 -15 -6 -33 17 -33 23 0 41 22 29 34 -8 8 -38 8 -46
-1z"/>
<path d="M3760 3709 c0 -15 5 -20 22 -17 34 5 37 38 4 38 -20 0 -26 -5 -26
-21z"/>
<path d="M4314 3719 c-3 -6 -2 -15 4 -21 15 -15 46 -5 50 15 3 12 -3 17 -22
17 -14 0 -28 -5 -32 -11z"/>
<path d="M6551 3721 c-7 -5 -10 -14 -7 -20 10 -16 43 -14 49 3 10 25 -14 34
-42 17z"/>
<path d="M7087 3723 c-16 -15 -6 -34 15 -31 29 4 38 38 10 38 -10 0 -22 -3
-25 -7z"/>
<path d="M7460 3715 c-10 -12 -9 -16 4 -21 18 -7 49 13 40 27 -8 14 -30 11
-44 -6z"/>
<path d="M8255 3771 c-7 -12 -5 -13 25 -14 11 -1 21 3 23 8 3 14 -40 19 -48 6z"/>
<path d="M8415 3771 c-7 -12 -5 -13 25 -14 11 -1 21 3 23 8 3 14 -40 19 -48 6z"/>
<path d="M4033 3094 c-13 -3 -23 -12 -23 -20 0 -8 -4 -14 -9 -14 -6 0 -22 -11
-37 -25 -15 -14 -33 -24 -41 -21 -7 3 -15 1 -18 -5 -4 -5 -21 -16 -38 -24
-127 -57 -173 -107 -202 -220 -20 -78 -19 -136 3 -216 67 -239 300 -375 537
-313 75 19 136 54 201 116 226 213 150 592 -144 716 -52 22 -180 37 -229 26z
m97 -167 c44 -30 103 -53 157 -62 23 -3 44 -12 46 -19 3 -6 1 -61 -3 -121 -5
-84 -12 -121 -30 -155 -53 -105 -163 -199 -217 -185 -42 10 -118 71 -159 126
-46 63 -60 112 -69 237 -8 113 -8 113 73 126 44 7 144 51 150 67 5 14 14 11
52 -14z"/>
<path d="M4127 2691 l-57 -60 -30 25 c-22 19 -34 23 -47 16 -15 -9 -12 -16 30
-57 l47 -47 67 72 c65 69 81 99 57 107 -6 2 -36 -23 -67 -56z"/>
<path d="M1931 3068 c-23 -6 -30 -12 -22 -17 9 -6 8 -10 -6 -14 -10 -4 -38
-22 -63 -42 -68 -53 -123 -88 -140 -90 -27 -2 -38 -14 -64 -68 -50 -101 -57
-234 -18 -331 84 -213 294 -326 505 -271 83 22 133 50 199 113 274 261 85 736
-290 731 -37 0 -82 -5 -101 -11z m209 -158 c0 -6 -22 -53 -50 -105 l-49 -95
79 0 c62 0 80 -3 80 -14 0 -8 -27 -47 -61 -88 -33 -40 -68 -82 -77 -93 -10
-11 -39 -47 -67 -80 -27 -33 -51 -62 -52 -64 -2 -2 -5 -2 -8 1 -3 3 13 56 35
118 22 62 40 115 40 117 0 2 -38 3 -85 3 -47 0 -85 2 -85 4 0 3 20 40 120 219
45 82 53 87 120 87 35 0 60 -4 60 -10z"/>
<path d="M6143 3068 c-13 -6 -23 -15 -23 -20 0 -4 -9 -8 -19 -8 -11 0 -21 -3
-23 -7 -5 -12 -66 -53 -78 -53 -6 0 -8 -5 -4 -12 4 -7 3 -8 -5 -4 -12 8 -71
-14 -71 -26 0 -4 -6 -5 -14 -2 -20 8 -73 -65 -101 -140 -19 -50 -25 -86 -25
-145 0 -170 86 -307 244 -389 70 -36 73 -37 186 -37 109 0 118 2 180 32 261
129 340 436 169 652 -24 31 -52 42 -44 19 3 -7 -11 -24 -30 -38 l-34 -25 -1
-110 0 -109 -138 -138 c-78 -78 -146 -138 -156 -138 -11 0 -65 46 -122 102
-81 80 -104 108 -104 129 0 21 29 57 132 164 l132 136 118 -3 c113 -3 118 -2
129 20 7 12 18 22 26 22 7 0 12 6 11 13 -2 6 3 11 10 9 19 -3 -9 37 -30 44
-10 3 -24 11 -30 17 -43 41 -235 72 -285 45z"/>
<path d="M8210 3074 c-8 -3 -34 -12 -58 -21 -31 -11 -42 -20 -40 -33 4 -21
-83 -91 -115 -93 -63 -5 -129 -142 -130 -271 -1 -127 35 -216 123 -307 87 -89
182 -129 311 -129 186 0 362 129 414 302 19 66 19 190 0 254 -35 118 -138 231
-252 275 -57 22 -217 36 -253 23z m161 -169 c74 -26 140 -105 152 -181 3 -17
16 -42 31 -57 23 -23 25 -32 21 -86 -3 -58 -6 -62 -62 -120 -50 -51 -66 -61
-113 -71 -30 -6 -68 -12 -84 -13 -32 -2 -53 21 -43 48 6 14 15 16 50 11 66
-10 98 -8 123 9 27 17 31 35 9 35 -12 0 -15 18 -15 104 0 66 4 107 11 112 14
8 5 56 -17 88 -22 35 -92 66 -146 66 -58 0 -123 -46 -146 -103 -13 -34 -13
-39 2 -56 14 -15 17 -36 15 -98 -2 -111 -3 -113 -50 -113 -62 0 -89 33 -89
110 0 51 4 63 24 81 15 13 26 37 30 64 8 48 49 111 93 143 58 41 134 51 204
27z"/>
<path d="M3055 2405 c0 -275 1 -386 2 -247 2 139 2 364 0 500 -1 136 -2 22 -2
-253z"/>
<path d="M5135 2405 c0 -275 1 -386 2 -247 2 139 2 364 0 500 -1 136 -2 22 -2
-253z"/>
<path d="M7295 2405 c0 -275 1 -386 2 -247 2 139 2 364 0 500 -1 136 -2 22 -2
-253z"/>
<path d="M6300 2803 c-11 -8 -20 -20 -20 -28 0 -17 27 -45 45 -45 21 0 45 29
45 55 0 28 -40 39 -70 18z"/>
<path d="M1717 2082 c-16 -3 -17 -14 -15 -85 3 -74 5 -82 23 -82 15 0 21 8 23
33 3 29 6 32 38 32 49 0 46 28 -3 32 -56 4 -52 32 5 36 34 3 43 7 40 20 -2 13
-14 17 -48 18 -25 0 -53 -1 -63 -4z"/>
<path d="M1913 2081 c-8 -5 -22 -37 -70 -158 -8 -21 35 -15 46 5 12 23 70 21
87 -2 10 -15 44 -23 44 -10 0 3 -14 40 -31 84 -30 74 -51 98 -76 81z m36 -93
c1 -5 -8 -8 -19 -8 -23 0 -24 4 -8 33 11 21 11 21 19 2 4 -11 8 -23 8 -27z"/>
<path d="M2072 2074 c-24 -17 -29 -56 -9 -71 6 -6 26 -15 42 -20 17 -5 30 -16
30 -24 0 -15 -28 -17 -57 -4 -23 9 -37 -23 -17 -36 21 -13 93 -11 107 3 16 16
15 63 0 75 -7 6 -26 15 -42 20 -45 14 -47 37 -3 30 48 -8 73 17 32 33 -37 14
-57 13 -83 -6z"/>
<path d="M2258 2083 c-33 -3 -48 -9 -48 -19 0 -8 10 -14 25 -14 24 0 25 -2 25
-70 0 -63 2 -70 20 -70 18 0 20 7 20 70 0 69 1 70 26 70 19 0 25 5 22 18 -3
18 -18 21 -90 15z"/>
<path d="M3498 2084 c-5 -4 -8 -45 -8 -91 0 -76 2 -83 20 -83 16 0 20 7 20 30
0 42 25 38 49 -7 6 -13 21 -23 31 -23 24 0 25 8 4 38 -15 21 -15 25 0 41 20
22 21 65 2 80 -17 14 -108 26 -118 15z m90 -56 c-2 -17 -11 -24 -30 -26 -24
-3 -28 0 -28 22 0 22 4 26 31 26 26 0 30 -3 27 -22z"/>
<path d="M3840 2000 l0 -90 61 0 c52 0 60 2 57 18 -2 12 -13 17 -38 17 l-35 1
-3 64 c-3 58 -12 79 -34 80 -5 0 -8 -40 -8 -90z"/>
<path d="M3994 2076 c-3 -7 -4 -46 -2 -87 2 -61 6 -74 21 -77 15 -3 17 6 17
81 0 67 -3 86 -15 91 -9 3 -18 0 -21 -8z"/>
<path d="M4132 2077 c-6 -7 -24 -46 -41 -87 -26 -65 -28 -75 -14 -79 9 -2 22
4 28 12 6 8 25 17 43 20 25 4 36 1 45 -14 6 -10 20 -19 31 -19 21 0 20 4 -20
100 -32 78 -50 94 -72 67z m34 -94 c-2 -3 -11 -3 -19 -1 -11 2 -12 9 -5 28
l10 25 9 -24 c5 -13 7 -26 5 -28z"/>
<path d="M4617 2083 c-4 -3 -7 -44 -7 -90 l0 -83 65 0 c51 0 65 3 65 15 0 11
-12 15 -45 15 -38 0 -45 3 -45 19 0 16 8 20 38 23 50 4 52 33 2 34 -25 0 -36
5 -38 17 -3 14 4 17 37 17 42 0 63 16 40 31 -16 10 -103 12 -112 2z"/>
<path d="M5483 2078 c-10 -13 -63 -148 -63 -161 0 -14 26 -7 43 13 22 26 51
25 76 -1 10 -11 26 -19 34 -17 12 2 8 19 -18 88 -33 83 -52 104 -72 78z m36
-90 c1 -5 -8 -8 -19 -8 -23 0 -24 4 -8 33 11 21 11 21 19 2 4 -11 8 -23 8 -27z"/>
<path d="M5633 2082 c-22 -3 -23 -8 -23 -88 0 -76 2 -85 18 -82 11 2 17 13 17
33 1 27 4 30 38 33 50 4 52 32 2 32 -28 0 -35 4 -35 20 0 17 7 20 40 20 29 0
40 4 40 15 0 8 -3 15 -7 16 -26 4 -71 4 -90 1z"/>
<path d="M5778 2083 c-28 -4 -28 -4 -28 -89 0 -76 2 -84 19 -84 15 0 21 8 23
33 3 29 6 32 38 33 25 0 36 5 38 17 3 14 -4 17 -37 17 -34 0 -41 3 -41 20 0
17 7 20 39 20 42 0 63 16 40 31 -14 9 -42 9 -91 2z"/>
<path d="M5944 2080 c-88 -36 -61 -170 34 -170 42 0 51 5 75 40 49 71 -29 164
-109 130z m70 -46 c24 -24 20 -61 -9 -80 -23 -15 -27 -15 -50 0 -26 17 -32 45
-15 77 13 23 53 25 74 3z"/>
<path d="M6128 2082 l-37 -3 2 -82 c2 -68 5 -82 19 -85 12 -2 18 5 20 24 4 39
24 41 43 5 9 -19 23 -31 35 -31 24 0 25 4 4 36 -15 23 -15 26 0 43 19 21 21
65 4 78 -18 14 -46 19 -90 15z m57 -57 c0 -31 -49 -28 -53 3 -3 20 0 23 25 20
20 -2 28 -8 28 -23z"/>
<path d="M6266 2083 c-3 -4 -6 -44 -6 -90 l0 -83 50 0 c41 0 56 5 75 25 49 48
23 143 -39 146 -12 1 -33 3 -48 4 -14 2 -29 1 -32 -2z m92 -45 c7 -7 12 -27
12 -45 0 -27 -5 -35 -26 -43 -36 -14 -44 -6 -44 51 0 44 2 49 23 49 13 0 28
-5 35 -12z"/>
<path d="M6492 2081 c-11 -6 -50 -94 -66 -148 -6 -18 -3 -23 11 -23 10 0 24 9
31 20 16 26 46 26 73 -1 11 -11 26 -19 33 -17 10 2 6 23 -16 85 -30 80 -44 98
-66 84z m24 -98 c-2 -3 -11 -3 -19 -1 -11 2 -12 9 -5 28 l10 25 9 -24 c5 -13
7 -26 5 -28z"/>
<path d="M6628 2083 c-15 -4 -18 -17 -18 -89 l0 -84 54 0 c58 0 86 16 86 49 0
10 -7 24 -15 31 -11 9 -13 16 -5 24 14 14 12 42 -5 56 -15 13 -68 19 -97 13z
m72 -48 c0 -8 -4 -15 -9 -15 -5 0 -16 -3 -25 -6 -12 -4 -16 0 -16 15 0 16 6
21 25 21 16 0 25 -6 25 -15z m8 -72 c-2 -11 -14 -19 -31 -21 -22 -3 -27 1 -27
17 0 17 6 21 31 21 24 0 30 -4 27 -17z"/>
<path d="M6783 2083 c-9 -3 -13 -31 -13 -89 l0 -84 60 0 c47 0 60 3 60 15 0 8
-6 15 -12 16 -7 1 -24 2 -38 2 -24 2 -25 6 -28 67 -3 68 -8 81 -29 73z"/>
<path d="M6948 2082 l-38 -3 0 -85 0 -84 63 0 c50 0 64 3 64 15 0 11 -12 15
-44 15 -36 0 -43 3 -43 20 0 16 7 20 36 20 28 0 35 3 32 18 -3 17 -7 18 -48
21 -11 0 -20 8 -20 16 0 11 11 15 41 15 33 0 40 3 37 18 -3 17 -15 20 -80 14z"/>
<path d="M7743 2080 c-24 -10 -37 -39 -27 -63 3 -8 23 -23 45 -31 21 -9 39
-21 39 -26 0 -17 -27 -22 -50 -10 -17 9 -25 9 -34 0 -17 -17 20 -40 66 -40 29
0 41 6 54 25 22 34 10 59 -36 78 -50 19 -54 42 -6 33 35 -7 57 7 39 25 -14 14
-66 19 -90 9z"/>
<path d="M7882 2083 c-17 -6 -5 -132 16 -155 21 -25 86 -24 112 2 16 16 20 33
20 85 0 58 -2 65 -20 65 -18 0 -20 -7 -20 -60 0 -48 -4 -61 -19 -70 -38 -20
-51 -3 -51 65 0 62 -9 78 -38 68z"/>
<path d="M8078 2084 c-5 -4 -8 -45 -8 -91 0 -75 2 -83 19 -83 14 0 21 8 23 27
3 24 9 29 42 34 55 9 73 50 41 93 -15 20 -103 35 -117 20z m87 -59 c0 -14 -8
-21 -27 -23 -24 -3 -28 0 -28 23 0 23 4 26 28 23 19 -2 27 -9 27 -23z"/>
<path d="M8464 2083 c-31 -6 -54 -35 -61 -76 -5 -31 -1 -40 25 -67 46 -46 116
-40 146 11 21 36 15 87 -12 113 -20 17 -65 26 -98 19z m72 -58 c30 -46 -17
-101 -65 -76 -24 13 -30 68 -9 89 20 20 56 14 74 -13z"/>
<path d="M8832 2083 c-56 -4 -67 -22 -21 -33 22 -5 24 -11 27 -73 3 -59 5 -67
22 -67 18 0 20 7 20 70 0 68 1 70 25 70 15 0 25 6 25 14 0 13 -24 28 -38 24
-4 -1 -31 -3 -60 -5z"/>
<path d="M3670 1995 l0 -85 65 0 c50 0 65 3 65 14 0 10 -14 16 -42 18 -31 2
-44 8 -46 21 -3 14 4 17 38 17 34 0 41 3 38 18 -2 12 -13 17 -38 17 -25 0 -36
5 -38 18 -3 14 4 17 42 17 34 0 46 4 46 15 0 12 -14 15 -65 15 l-65 0 0 -85z"/>
<path d="M4270 1995 l0 -85 59 0 c41 0 65 5 75 16 18 18 21 50 5 60 -6 3 -8
17 -4 31 13 51 0 63 -71 63 l-64 0 0 -85z m100 41 c0 -16 -34 -31 -50 -21 -22
14 -10 35 20 35 19 0 30 -5 30 -14z m4 -64 c2 -4 1 -14 -3 -21 -12 -18 -55
-10 -59 12 -3 13 3 17 27 17 16 0 32 -4 35 -8z"/>
<path d="M4450 1996 l0 -86 65 0 c50 0 65 3 65 14 0 10 -14 16 -42 18 l-42 3
-1 65 c0 60 -2 65 -22 68 -22 3 -23 1 -23 -82z"/>
<path d="M8240 1995 c0 -78 2 -85 20 -85 14 0 20 7 20 24 0 20 7 25 45 35 50
13 66 43 46 87 -9 22 -17 24 -71 24 l-60 0 0 -85z m95 30 c0 -14 -8 -21 -27
-23 -24 -3 -28 0 -28 23 0 23 4 26 28 23 19 -2 27 -9 27 -23z"/>
<path d="M8620 1995 c0 -77 2 -85 19 -85 14 0 21 8 23 27 4 38 24 39 43 4 9
-19 23 -31 35 -31 23 0 24 1 8 35 -9 19 -9 28 0 37 16 16 15 71 0 86 -7 7 -38
12 -70 12 l-58 0 0 -85z m98 33 c-2 -17 -11 -24 -30 -26 -24 -3 -28 0 -28 22
0 22 4 26 31 26 26 0 30 -3 27 -22z"/>
<path d="M1293 1760 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M1341 1758 c2 -52 2 -52 8 -13 l6 40 25 -37 c14 -21 28 -38 33 -38 4
0 6 24 5 53 -1 35 -2 42 -5 20 -5 -41 -17 -42 -40 -3 -25 43 -33 37 -32 -22z"/>
<path d="M1462 1797 c-13 -15 -5 -30 26 -46 26 -14 19 -35 -9 -26 -11 4 -19 2
-19 -4 0 -17 57 -13 64 4 5 15 -1 23 -39 50 -19 14 -19 14 8 15 16 0 26 4 22
10 -9 14 -41 12 -53 -3z"/>
<path d="M1550 1800 c0 -5 7 -10 15 -10 11 0 15 -12 17 -42 l1 -43 4 40 c2 22
11 46 20 53 14 10 12 12 -20 12 -20 0 -37 -4 -37 -10z"/>
<path d="M1676 1803 c-10 -10 -36 -72 -36 -86 0 -7 4 -7 12 1 16 16 55 15 61
0 2 -7 7 -10 11 -7 5 5 -30 99 -38 99 -1 0 -6 -3 -10 -7z m18 -38 c3 -9 0 -15
-9 -15 -8 0 -15 7 -15 15 0 8 4 15 9 15 5 0 11 -7 15 -15z"/>
<path d="M1762 1760 c0 -47 2 -50 7 -20 l6 35 24 -32 c14 -18 28 -33 33 -33 4
0 7 24 6 53 -1 35 -2 42 -5 20 -2 -18 -7 -33 -11 -33 -4 0 -19 14 -34 32 l-27
33 1 -55z"/>
<path d="M1870 1800 c0 -5 6 -10 14 -10 10 0 16 -14 19 -42 l4 -43 1 43 c1 30
6 42 17 42 8 0 15 5 15 10 0 6 -16 10 -35 10 -19 0 -35 -4 -35 -10z"/>
<path d="M2027 1803 c-4 -3 -7 -26 -7 -50 0 -42 1 -43 33 -43 38 0 57 15 57
45 0 38 -60 72 -83 48z m58 -48 c0 -23 -5 -31 -22 -33 -20 -3 -23 1 -23 33 0
32 3 36 23 33 17 -2 22 -10 22 -33z"/>
<path d="M2140 1760 l0 -50 38 1 c27 1 30 3 12 6 -37 7 -49 23 -22 29 25 7 30
24 7 24 -8 0 -15 5 -15 10 0 6 9 10 19 10 11 0 23 5 26 10 4 6 -8 10 -29 10
l-36 0 0 -50z"/>
<path d="M2242 1763 l-2 -53 33 1 c29 1 30 2 7 8 -21 6 -26 15 -31 51 l-6 45
-1 -52z"/>
<path d="M2378 1805 c-9 -10 29 -90 43 -90 13 0 42 72 36 89 -2 6 -9 -6 -16
-26 -7 -21 -16 -38 -20 -38 -5 0 -15 16 -22 36 -8 20 -17 33 -21 29z"/>
<path d="M2490 1760 l0 -50 38 1 c30 2 32 3 10 6 -32 5 -38 33 -8 33 11 0 20
5 20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 11 10 25 10 14 0 25 5 25 10
0 6 -16 10 -35 10 l-35 0 0 -50z"/>
<path d="M2590 1760 c0 -27 5 -50 10 -50 6 0 10 7 10 15 0 8 6 15 14 15 8 0
16 -7 20 -15 3 -8 11 -15 17 -15 9 0 8 4 0 14 -9 11 -9 19 0 34 17 27 -3 52
-42 52 -28 0 -29 -2 -29 -50z m60 14 c0 -8 -9 -14 -20 -14 -19 0 -27 19 -14
33 10 9 34 -4 34 -19z"/>
<path d="M2691 1805 c0 -5 6 -19 14 -29 8 -11 15 -30 15 -43 0 -13 5 -23 10
-23 6 0 10 10 10 23 0 12 7 31 15 41 8 11 15 25 15 30 0 6 -9 0 -19 -14 l-19
-24 -21 24 c-11 14 -20 21 -20 15z"/>
<path d="M3465 1801 c-3 -5 -2 -12 3 -15 5 -3 7 -18 4 -34 -2 -16 1 -33 7 -36
7 -5 11 9 11 43 0 47 -10 65 -25 42z"/>
<path d="M3546 1795 c-32 -33 -9 -90 35 -83 21 3 24 8 24 48 0 38 -3 45 -21
48 -12 2 -29 -4 -38 -13z m49 -40 c0 -23 -4 -30 -20 -30 -21 0 -31 25 -21 51
11 28 41 12 41 -21z"/>
<path d="M3666 1794 c-35 -34 -10 -89 36 -82 18 2 24 10 26 36 5 54 -29 80
-62 46z m52 -30 c3 -23 -21 -49 -38 -39 -5 3 -10 20 -10 36 0 26 3 30 23 27
13 -2 23 -11 25 -24z"/>
<path d="M3777 1803 c-15 -15 -7 -43 13 -43 23 0 26 -10 8 -28 -6 -6 -9 -14
-7 -17 7 -6 59 73 59 88 -1 7 -8 -1 -18 -18 l-17 -30 -3 28 c-3 25 -20 35 -35
20z m19 -30 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z"/>
<path d="M3993 1798 c9 -7 18 -31 20 -53 l4 -40 1 42 c1 28 8 45 20 52 14 8 9
10 -22 11 -34 0 -37 -2 -23 -12z"/>
<path d="M4090 1760 c0 -27 5 -50 10 -50 6 0 10 9 10 20 0 11 4 20 10 20 5 0
14 -9 20 -20 6 -11 15 -20 21 -20 6 0 6 6 0 18 -7 13 -7 22 0 29 6 6 8 20 4
32 -5 16 -15 21 -41 21 l-34 0 0 -50z m60 15 c0 -8 -9 -15 -20 -15 -11 0 -20
7 -20 15 0 8 9 15 20 15 11 0 20 -7 20 -15z"/>
<path d="M4278 1768 c-2 -35 -7 -43 -23 -43 -16 0 -21 8 -23 38 -4 46 -22 49
-22 4 0 -39 15 -57 47 -57 25 0 43 26 43 64 0 43 -19 38 -22 -6z"/>
<path d="M4347 1803 c-15 -14 -6 -40 19 -51 28 -14 23 -36 -7 -27 -11 4 -19 2
-19 -4 0 -19 57 -13 64 6 7 16 -16 43 -36 43 -4 0 -8 5 -8 10 0 6 9 10 21 10
11 0 17 5 14 10 -7 11 -38 13 -48 3z"/>
<path d="M4453 1803 c13 -3 17 -15 17 -49 0 -30 4 -43 11 -39 6 4 8 22 6 41
-4 25 0 37 12 44 12 7 6 9 -24 9 -22 -1 -32 -3 -22 -6z"/>
<path d="M4560 1760 l0 -50 33 1 c30 2 30 2 5 6 -32 5 -38 33 -8 33 11 0 20 5
20 10 0 6 -8 10 -17 8 -28 -5 -21 25 7 33 23 6 22 7 -7 8 -33 1 -33 1 -33 -49z"/>
<path d="M4670 1760 c0 -49 1 -50 29 -50 32 0 61 22 61 46 0 22 -38 54 -65 54
-23 0 -25 -3 -25 -50z m67 14 c8 -22 -10 -49 -33 -49 -14 0 -18 8 -19 33 -1
27 3 32 22 32 13 0 26 -7 30 -16z"/>
<path d="M5670 1761 l0 -51 34 0 c38 0 44 10 36 60 -4 31 -9 35 -37 38 l-33 3
0 -50z m50 19 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0
20 -4 20 -10z m8 -42 c-7 -20 -48 -23 -48 -4 0 11 9 16 26 16 16 0 24 -5 22
-12z"/>
<path d="M5790 1760 l0 -50 38 1 c35 1 35 2 8 8 -35 7 -47 31 -17 31 12 0 21
5 21 11 0 6 -7 9 -15 6 -8 -4 -17 -1 -21 5 -8 13 16 30 34 23 6 -2 12 0 12 5
0 6 -13 10 -30 10 -29 0 -30 -1 -30 -50z"/>
<path d="M5907 1803 c-16 -15 -6 -43 18 -49 14 -3 25 -13 25 -21 0 -11 -7 -13
-25 -9 -14 4 -25 2 -25 -4 0 -12 57 -13 64 -1 9 14 -4 41 -19 41 -7 0 -18 7
-25 15 -11 13 -8 15 14 15 16 0 25 4 21 10 -7 11 -38 13 -48 3z"/>
<path d="M6013 1803 c13 -3 17 -15 17 -49 0 -24 5 -44 10 -44 6 0 10 20 10 44
0 34 4 46 18 49 9 3 -3 5 -28 5 -25 0 -37 -2 -27 -5z"/>
<path d="M6187 1804 c-10 -10 -9 -82 2 -88 5 -3 11 4 14 15 3 12 10 18 15 15
5 -3 18 1 28 9 15 11 17 18 8 32 -11 19 -54 29 -67 17z m53 -29 c0 -8 -9 -15
-20 -15 -11 0 -20 7 -20 15 0 8 9 15 20 15 11 0 20 -7 20 -15z"/>
<path d="M6301 1758 c0 -42 2 -48 9 -30 12 27 17 28 39 1 17 -21 17 -20 16 27
0 48 -1 49 -32 52 l-33 3 1 -53z m59 17 c0 -9 -9 -15 -25 -15 -16 0 -25 6 -25
15 0 9 9 15 25 15 16 0 25 -6 25 -15z"/>
<path d="M6423 1760 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M6492 1798 c-18 -18 -15 -75 4 -82 25 -10 64 -7 64 4 0 6 -10 8 -23
5 -30 -8 -51 16 -42 46 6 17 13 20 36 17 18 -3 28 -1 26 6 -5 16 -50 19 -65 4z"/>
<path d="M6610 1760 l0 -50 38 1 c35 1 35 2 8 8 -35 7 -47 31 -17 31 12 0 21
5 21 10 0 6 -3 9 -7 9 -40 -6 -42 21 -2 32 21 6 21 7 -8 8 -33 1 -33 1 -33
-49z"/>
<path d="M6727 1803 c-15 -14 -6 -40 19 -51 28 -13 23 -37 -7 -29 -11 3 -19 1
-19 -4 0 -5 14 -9 30 -9 25 0 30 4 30 23 0 16 -9 28 -27 37 l-28 14 28 4 c15
2 25 8 22 13 -7 10 -38 12 -48 2z"/>
<path d="M7555 1800 c-4 -6 5 -10 19 -10 33 0 34 -23 1 -44 -34 -23 -31 -36 8
-35 17 1 24 3 15 6 -15 4 -15 6 0 32 8 15 13 35 9 44 -7 19 -42 23 -52 7z"/>
<path d="M7678 1777 c-34 -44 -34 -47 -3 -47 14 0 25 -5 25 -12 0 -9 3 -9 12
0 8 8 8 24 2 53 l-9 43 -27 -37z m19 -34 c-3 -3 -11 -2 -17 2 -8 5 -7 11 2 22
12 15 13 14 16 -1 2 -10 1 -20 -1 -23z"/>
<path d="M7782 1759 c-12 -29 -20 -55 -17 -57 7 -7 47 87 43 99 -2 6 -13 -13
-26 -42z"/>
<path d="M7865 1800 c4 -6 10 -8 15 -5 18 11 20 -15 5 -46 -9 -17 -14 -33 -11
-36 5 -6 46 70 46 87 0 5 -14 10 -31 10 -18 0 -28 -4 -24 -10z"/>
<path d="M8050 1770 c-23 -45 -27 -71 -8 -52 16 16 55 15 61 0 2 -7 7 -10 11
-7 6 6 -31 99 -39 99 -3 0 -14 -18 -25 -40z m29 -19 c-15 -5 -22 6 -14 19 6 9
10 9 16 -1 5 -8 4 -15 -2 -18z"/>
<path d="M8167 1803 c-16 -15 -6 -43 18 -49 31 -8 27 -30 -4 -27 -11 2 -21 -2
-21 -8 0 -6 14 -9 32 -7 42 4 50 33 14 49 -31 15 -34 29 -5 29 11 0 17 5 14
10 -7 11 -38 13 -48 3z"/>
<path d="M8277 1803 c-16 -15 -6 -43 18 -49 14 -3 25 -13 25 -21 0 -11 -7 -13
-25 -9 -14 4 -25 2 -25 -4 0 -15 46 -12 59 4 10 12 7 18 -13 31 -32 21 -36 49
-5 40 15 -5 19 -4 15 4 -8 12 -39 15 -49 4z"/>
<path d="M8380 1761 c0 -29 4 -50 8 -47 9 6 8 84 -2 93 -3 4 -6 -17 -6 -46z"/>
<path d="M8444 1795 c-7 -18 12 -45 32 -45 8 0 14 -7 14 -16 0 -12 -6 -15 -25
-10 -15 4 -25 2 -25 -4 0 -7 14 -10 32 -8 42 4 50 33 14 49 -31 14 -34 29 -6
29 11 0 20 5 20 10 0 16 -50 12 -56 -5z"/>
<path d="M8550 1800 c0 -5 6 -9 13 -7 7 1 14 -15 18 -43 l6 -45 1 42 c2 28 8
45 20 52 14 8 10 10 -20 11 -21 0 -38 -4 -38 -10z"/>
<path d="M8664 1765 c-9 -25 -14 -48 -10 -52 3 -3 6 -1 6 5 0 16 57 15 64 0 9
-19 -3 37 -14 67 -14 36 -26 31 -46 -20z m40 0 c3 -9 0 -15 -9 -15 -8 0 -15 7
-15 15 0 8 4 15 9 15 5 0 11 -7 15 -15z"/>
<path d="M8782 1760 c1 -34 3 -43 5 -22 5 40 17 41 40 2 25 -43 33 -37 31 23
-1 46 -2 48 -5 12 l-4 -39 -34 39 -34 40 1 -55z"/>
<path d="M8922 1798 c-21 -21 -15 -74 11 -84 25 -12 57 -7 57 7 0 6 -9 7 -20
4 -25 -8 -50 10 -50 36 0 22 26 38 53 31 14 -3 18 -1 13 6 -9 16 -49 15 -64 0z"/>
<path d="M9037 1803 c-4 -3 -7 -26 -7 -50 l0 -43 38 1 c30 2 32 3 10 6 -32 5
-38 33 -8 33 11 0 20 5 20 10 0 6 -9 10 -21 10 -12 0 -19 5 -16 13 2 6 11 12
20 12 8 0 19 4 23 8 4 4 -6 7 -23 7 -16 0 -33 -3 -36 -7z"/>
<path d="M2330 1754 c0 -25 4 -43 9 -39 12 7 12 85 0 85 -5 0 -9 -21 -9 -46z"/>
<path d="M3834 1745 c-7 -18 3 -35 21 -35 21 0 28 19 15 35 -16 19 -29 19 -36
0z m22 -22 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z"/>
<path d="M3205 1428 c-352 -4 -649 -10 -660 -13 -35 -8 -109 -63 -134 -100
l-24 -35 -217 0 c-119 0 -220 -3 -223 -7 -4 -3 -2 -12 4 -20 9 -10 8 -13 -2
-14 -8 0 -5 -4 6 -9 11 -5 109 -9 219 -9 165 -1 197 -3 193 -15 -3 -8 -11 -34
-18 -57 -7 -24 -16 -48 -20 -54 -13 -19 -39 -137 -39 -179 0 -58 45 -121 108
-148 40 -18 58 -20 136 -14 211 14 2601 15 3446 0 1099 -19 2699 -14 2776 8
56 16 137 77 160 121 14 27 24 57 75 232 32 111 31 171 -3 222 -49 75 -29 72
-649 78 -305 3 -662 10 -794 15 -286 12 -3429 10 -4340 -2z m-312 -217 c18
-18 18 -19 -3 -39 -17 -16 -27 -19 -41 -12 -22 12 -66 13 -73 1 -7 -11 11 -26
48 -38 72 -23 85 -105 23 -144 -44 -28 -138 -22 -170 9 l-21 22 20 21 c21 20
23 20 53 4 37 -19 76 -17 76 5 0 8 -18 21 -40 29 -50 19 -64 37 -65 82 0 38
17 60 60 78 35 15 111 4 133 -18z m1044 -3 c30 -28 29 -42 -3 -57 -22 -10 -30
-9 -44 4 -26 23 -68 19 -95 -11 -31 -34 -32 -76 -3 -104 26 -24 46 -25 76 -5
24 18 62 6 62 -19 0 -31 -41 -51 -107 -51 -60 0 -67 2 -94 33 -24 26 -29 41
-29 81 0 62 30 108 90 139 53 27 112 23 147 -10z m260 6 c57 -36 69 -124 26
-183 -73 -98 -223 -95 -253 6 -39 128 116 247 227 177z m1112 -3 c35 -24 36
-37 7 -56 -23 -16 -27 -16 -41 -1 -25 24 -72 20 -101 -9 -35 -35 -31 -93 9
-115 25 -14 30 -13 58 3 30 17 33 17 50 1 26 -23 24 -29 -15 -53 -63 -39 -160
-20 -185 36 -15 33 -14 87 3 126 35 83 145 118 215 68z m-2161 -8 c-3 -23 -9
-29 -41 -34 -20 -3 -39 -8 -40 -10 -2 -2 -12 -47 -23 -99 l-19 -95 -37 -3
c-21 -2 -38 -1 -38 2 0 3 9 44 20 91 27 115 27 115 -15 115 -36 0 -42 10 -29
44 5 13 25 16 116 16 l109 0 -3 -27z m162 25 c0 -2 11 -61 24 -131 25 -137 24
-142 -26 -135 -15 2 -24 11 -26 26 -3 20 -9 22 -56 22 -47 0 -54 -3 -64 -25
-9 -20 -19 -25 -48 -25 -44 0 -46 -4 47 152 l70 118 39 0 c22 0 40 -1 40 -2z
m148 -45 c8 -24 17 -43 21 -43 4 0 21 20 39 45 27 39 36 45 67 45 19 0 35 -3
35 -8 0 -4 -27 -41 -60 -82 -45 -57 -62 -87 -70 -127 -11 -51 -12 -53 -46 -53
-37 0 -39 5 -23 63 9 32 6 47 -14 100 -44 112 -44 109 0 105 35 -3 39 -6 51
-45z m954 -23 c20 -39 39 -67 41 -63 3 5 11 36 18 71 13 61 14 62 46 62 20 0
33 -5 33 -13 0 -16 -50 -240 -56 -249 -3 -5 -17 -8 -32 -8 -24 0 -32 9 -62 70
-19 38 -38 70 -41 70 -6 0 -20 -47 -34 -112 -4 -23 -11 -28 -34 -28 -15 0 -30
2 -33 5 -4 5 35 212 47 253 3 6 19 12 37 12 31 0 36 -5 70 -70z m287 -2 c43
-78 43 -78 61 15 11 56 12 57 46 57 19 0 34 -3 33 -7 0 -5 -12 -64 -27 -133
l-27 -125 -33 -3 c-30 -3 -34 0 -54 44 -11 26 -29 61 -38 77 l-18 28 -11 -53
c-7 -29 -14 -63 -17 -75 -3 -19 -11 -23 -39 -23 -19 0 -35 2 -35 5 0 9 50 239
55 253 2 6 18 12 34 12 26 0 34 -8 70 -72z m381 65 c0 -5 -3 -18 -6 -30 -6
-21 -12 -23 -69 -23 -54 0 -63 -3 -68 -20 -5 -18 0 -20 47 -20 61 0 65 -2 58
-35 -4 -23 -9 -25 -62 -25 -49 0 -58 -3 -63 -19 -7 -28 -1 -31 65 -31 60 0 67
-6 52 -44 -5 -13 -24 -16 -105 -16 -113 0 -108 -6 -84 93 8 34 19 88 25 120
l11 57 100 0 c54 0 99 -3 99 -7z m510 -7 c0 -34 -13 -46 -50 -46 -38 0 -38 0
-49 -52 -35 -165 -32 -158 -62 -158 -15 0 -30 4 -33 8 -3 5 4 48 15 97 10 49
19 93 19 97 0 4 -16 8 -35 8 -30 0 -35 3 -35 23 0 13 3 27 7 30 3 4 55 7 115
7 87 0 108 -3 108 -14z m222 9 c3 -3 3 -16 0 -30 -4 -22 -9 -24 -70 -27 -54
-2 -67 -6 -70 -20 -3 -15 5 -18 52 -18 57 0 64 -6 50 -44 -5 -12 -20 -16 -60
-16 -42 0 -55 -4 -63 -19 -15 -26 -5 -31 61 -31 59 0 59 0 56 -27 l-3 -28 -94
-3 c-52 -1 -98 1 -102 5 -5 5 0 44 10 88 10 44 22 98 26 120 4 22 9 43 11 47
6 9 188 11 196 3z m215 -15 c73 -44 64 -159 -18 -216 -34 -24 -53 -28 -125
-32 -63 -3 -84 -1 -84 8 0 17 51 243 57 253 2 4 34 7 71 7 49 0 76 -5 99 -20z
m455 4 l31 -16 -21 -20 c-18 -18 -23 -19 -55 -7 -29 10 -39 10 -52 -1 -23 -19
-15 -31 35 -49 26 -10 50 -27 59 -42 12 -22 12 -29 -3 -61 -28 -57 -101 -76
-172 -42 -37 18 -43 34 -19 54 12 10 21 10 44 0 37 -15 86 -10 86 10 0 8 -22
26 -50 40 -45 23 -50 29 -53 62 -6 76 86 115 170 72z m271 9 c3 -5 1 -18 -4
-30 -6 -18 -16 -23 -43 -23 -37 0 -39 -3 -51 -70 -20 -110 -27 -128 -57 -132
-16 -3 -31 -2 -33 2 -2 4 5 44 15 89 27 110 27 111 -15 111 -30 0 -35 3 -35
23 0 13 3 27 7 30 9 10 211 9 216 0z m163 -40 c3 -27 14 -85 24 -130 10 -46
17 -83 17 -84 -1 0 -17 -2 -35 -3 -29 -2 -34 1 -39 26 -5 26 -9 28 -49 28 -40
0 -74 -18 -74 -41 0 -5 -16 -9 -35 -9 -19 0 -35 2 -35 5 0 2 18 34 39 69 22
35 49 84 61 108 32 63 49 78 86 78 31 0 33 -2 40 -47z m142 0 c7 -24 17 -43
21 -43 4 0 24 20 44 45 29 35 45 45 67 45 17 0 30 -4 30 -8 0 -4 -26 -39 -57
-77 -42 -49 -62 -84 -73 -124 -14 -49 -18 -54 -43 -56 l-28 -1 6 56 c5 46 2
68 -19 124 -14 38 -26 73 -26 78 0 5 14 8 32 6 27 -3 33 -9 46 -45z m441 -5
c6 -29 17 -88 25 -130 l13 -78 -33 0 c-26 0 -33 4 -36 23 -3 19 -10 22 -55 25
-29 2 -53 -1 -53 -5 -1 -21 -32 -45 -59 -47 -17 -1 -31 -1 -31 1 0 9 37 75 92
166 57 91 62 97 93 97 32 0 34 -2 44 -52z m176 20 c-4 -18 -9 -41 -12 -51 -4
-16 1 -18 48 -15 l53 3 11 45 c11 44 29 58 59 47 11 -4 9 -29 -11 -124 -14
-65 -29 -123 -34 -129 -5 -6 -19 -10 -31 -9 -25 2 -29 24 -15 78 7 27 7 27
-42 27 l-50 0 -15 -53 c-15 -51 -17 -53 -46 -49 -22 3 -29 9 -26 21 2 9 14 59
26 111 30 136 27 130 61 130 29 0 30 -2 24 -32z m415 25 c0 -5 -3 -18 -6 -30
-5 -20 -14 -22 -73 -25 -58 -3 -66 -5 -66 -23 0 -17 7 -20 40 -21 64 -1 67 -3
63 -26 -3 -20 -10 -24 -63 -28 -53 -4 -60 -8 -63 -27 -3 -22 0 -23 62 -23 68
0 70 -1 57 -34 -6 -17 -17 -19 -101 -17 -52 1 -96 3 -97 4 -2 2 45 226 52 245
5 13 195 18 195 5z m194 -5 c2 -7 11 -56 21 -108 9 -52 19 -107 22 -122 5 -26
4 -28 -28 -25 -26 2 -34 8 -39 27 -5 20 -13 26 -39 28 -48 5 -79 -5 -86 -27
-6 -19 -61 -35 -70 -21 -3 4 30 64 72 134 73 121 77 126 110 126 18 0 35 -6
37 -12z m255 6 c17 -4 43 -17 57 -31 24 -22 26 -29 22 -85 -4 -58 -7 -64 -47
-99 -41 -36 -45 -38 -127 -41 -47 -2 -87 -2 -88 0 -3 2 41 223 49 250 5 13 80
17 134 6z m-2399 -199 c17 -21 -2 -65 -28 -65 -38 0 -54 37 -26 64 20 20 38
20 54 1z m2550 -19 c0 -28 -24 -51 -45 -42 -40 15 -23 66 21 66 19 0 24 -5 24
-24z"/>
<path d="M4061 1144 c-49 -62 -7 -141 60 -114 37 16 62 60 53 95 -13 50 -80
61 -113 19z"/>
<path d="M3236 1118 c-22 -30 -20 -48 4 -48 16 0 20 7 20 35 0 41 -3 43 -24
13z"/>
<path d="M5898 1103 c-9 -38 -13 -72 -9 -76 12 -12 81 9 97 30 7 10 14 35 14
55 0 40 -19 58 -62 58 -21 0 -26 -8 -40 -67z"/>
<path d="M6842 1127 c-5 -6 -15 -22 -21 -34 -11 -21 -10 -23 19 -23 27 0 30 3
30 29 0 34 -13 47 -28 28z"/>
<path d="M7417 1121 c-24 -41 -22 -53 11 -49 24 3 27 7 24 33 -5 44 -16 49
-35 16z"/>
<path d="M8205 1110 c-20 -38 -19 -40 10 -40 22 0 25 4 25 35 0 43 -14 45 -35
5z"/>
<path d="M8456 1148 c-28 -131 -27 -134 28 -124 91 17 101 146 11 146 -28 0
-36 -4 -39 -22z"/>
<path d="M1640 1090 c-25 -4 -35 -8 -22 -8 12 -1 22 -6 22 -10 0 -5 -10 -14
-22 -20 -17 -8 55 -11 280 -11 l303 -1 8 23 c5 12 7 25 4 30 -5 9 -511 7 -573
-3z"/>
<path d="M2065 910 c-19 -8 -19 -9 -1 -9 17 -1 17 -3 -4 -21 l-23 -20 70 0
c64 0 71 2 81 24 6 13 8 27 5 30 -9 9 -105 6 -128 -4z"/>
<path d="M3229 554 c-3 -5 -4 -31 -4 -59 0 -49 1 -50 32 -53 55 -5 91 49 60
91 -13 19 -82 35 -88 21z m62 -24 c35 -19 14 -70 -30 -70 -6 0 -11 18 -11 40
0 41 8 47 41 30z"/>
<path d="M3410 505 c-21 -52 -20 -91 1 -52 6 9 21 17 34 17 13 0 28 -8 34 -17
5 -10 12 -15 16 -12 8 9 -41 119 -53 119 -5 0 -20 -25 -32 -55z m50 -11 c0 -8
-7 -14 -15 -14 -15 0 -21 21 -9 33 10 9 24 -2 24 -19z"/>
<path d="M3550 551 c0 -5 9 -11 20 -14 16 -4 20 -14 20 -52 0 -30 4 -44 11
-40 6 4 9 26 7 48 -2 33 1 43 15 45 33 7 17 19 -28 20 -25 1 -45 -2 -45 -7z"/>
<path d="M3714 504 c-25 -56 -24 -85 0 -51 16 21 55 22 62 2 7 -17 24 -20 24
-4 0 19 -42 109 -52 109 -5 0 -20 -25 -34 -56z m41 -13 c-9 -16 -25 -3 -18 15
4 10 9 12 15 6 6 -6 7 -15 3 -21z"/>
<path d="M3970 500 c0 -33 4 -60 10 -60 6 0 10 11 10 25 0 21 5 25 31 25 17 0
28 4 24 10 -3 6 -18 10 -31 10 -34 0 -26 24 9 28 42 5 32 22 -13 22 l-40 0 0
-60z"/>
<path d="M4142 544 c-44 -30 -20 -104 34 -104 28 0 64 32 64 58 0 24 -36 62
-58 62 -10 0 -28 -7 -40 -16z m52 -10 c22 -8 21 -63 0 -71 -36 -13 -68 33 -44
62 14 17 21 18 44 9z"/>
<path d="M4310 500 c0 -33 4 -60 10 -60 6 0 10 9 10 20 0 26 17 25 40 -2 10
-13 22 -20 26 -16 4 4 1 15 -6 23 -10 12 -10 19 -2 27 30 30 1 68 -52 68 -25
0 -26 -2 -26 -60z m65 20 c0 -8 -10 -16 -22 -18 -18 -3 -23 2 -23 18 0 16 5
21 23 18 12 -2 22 -10 22 -18z"/>
<path d="M4575 548 c-2 -7 -3 -33 -2 -58 2 -43 3 -45 36 -48 18 -2 38 1 44 7
8 8 2 11 -21 11 -22 0 -32 5 -32 15 0 9 9 15 25 15 33 0 32 18 0 22 -37 4 -35
22 3 26 18 2 30 8 27 13 -9 14 -75 11 -80 -3z"/>
<path d="M4727 553 c-7 -11 40 -113 52 -113 5 0 19 25 30 55 24 64 24 65 11
65 -5 0 -15 -18 -21 -40 -7 -22 -15 -40 -19 -40 -5 0 -15 18 -24 40 -16 40
-21 46 -29 33z"/>
<path d="M4900 500 l0 -60 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0 -30
5 -30 15 0 9 9 15 25 15 14 0 25 5 25 10 0 6 -11 10 -25 10 -16 0 -25 6 -25
15 0 10 10 15 31 15 41 0 29 15 -15 18 l-36 3 0 -61z"/>
<path d="M5057 553 c-11 -10 -8 -101 3 -108 6 -3 10 3 10 14 0 28 36 28 45 1
3 -11 11 -20 16 -20 13 0 11 14 -3 28 -9 9 -10 15 -2 20 20 14 23 40 5 56 -18
16 -62 22 -74 9z m63 -33 c0 -21 -33 -29 -45 -10 -9 15 4 30 26 30 12 0 19 -7
19 -20z"/>
<path d="M5210 548 c0 -7 9 -24 20 -38 11 -14 20 -35 20 -48 0 -13 4 -20 10
-17 6 3 10 16 10 29 0 12 7 31 15 42 25 33 16 52 -10 20 l-24 -30 -12 27 c-13
28 -29 36 -29 15z"/>
<path d="M5392 553 c-7 -3 -17 -16 -22 -29 -28 -73 76 -119 109 -48 22 50 -33
99 -87 77z m62 -35 c14 -23 -3 -52 -32 -56 -16 -2 -23 3 -28 22 -12 48 35 74
60 34z"/>
<path d="M5560 498 c0 -63 15 -72 22 -14 l3 30 25 -37 c14 -20 30 -35 35 -34
14 5 19 97 6 110 -8 8 -11 0 -11 -26 0 -20 -3 -37 -7 -37 -5 0 -19 16 -33 35
-14 19 -28 35 -32 35 -5 0 -8 -28 -8 -62z"/>
<path d="M5734 546 c-3 -7 -4 -33 -2 -57 3 -43 4 -44 41 -47 41 -4 52 15 12
20 -14 2 -26 8 -26 13 0 6 12 11 26 13 14 2 25 7 25 12 0 5 -11 10 -25 12 -35
4 -36 22 -2 26 39 5 33 22 -8 22 -21 0 -38 -6 -41 -14z"/>
<path d="M6087 553 c-4 -3 -7 -30 -7 -60 l0 -53 40 0 c45 0 55 17 13 22 -39 5
-40 26 -1 30 33 4 29 9 -20 24 -21 6 -3 24 24 24 13 0 24 5 24 10 0 11 -63 14
-73 3z"/>
<path d="M6236 538 c35 -111 46 -119 75 -53 27 62 20 95 -8 35 l-21 -45 -18
43 c-18 43 -41 60 -28 20z"/>
<path d="M6407 553 c-2 -5 -3 -30 -3 -58 l1 -50 43 -3 c25 -2 42 1 42 7 0 6
-13 11 -30 11 -20 0 -30 5 -30 15 0 9 9 15 25 15 14 0 25 5 25 10 0 6 -11 10
-25 10 -16 0 -25 6 -25 15 0 10 10 15 31 15 17 0 28 4 24 10 -7 12 -72 14 -78
3z"/>
<path d="M6567 553 c-11 -10 -8 -113 3 -113 6 0 10 9 10 20 0 27 24 25 43 -2
8 -13 18 -20 22 -16 4 4 2 15 -5 23 -10 12 -10 19 -2 27 18 18 14 46 -7 58
-22 11 -54 13 -64 3z m58 -33 c0 -8 -10 -16 -22 -18 -18 -3 -23 2 -23 18 0 16
5 21 23 18 12 -2 22 -10 22 -18z"/>
<path d="M6729 524 c12 -19 21 -46 21 -60 0 -13 5 -24 10 -24 6 0 10 9 10 19
0 11 10 36 21 56 26 43 20 57 -9 21 l-20 -26 -16 25 c-26 39 -41 29 -17 -11z"/>
<path d="M6877 554 c-5 -5 3 -34 28 -103 8 -21 31 4 40 42 l7 32 12 -39 c6
-22 16 -41 22 -43 13 -4 44 67 44 100 -1 21 -1 22 -15 3 -8 -11 -15 -28 -15
-38 0 -29 -18 -21 -25 12 -10 45 -24 46 -42 3 l-16 -38 -11 32 c-12 36 -20 46
-29 37z"/>
<path d="M7108 554 c-12 -11 -10 -102 2 -109 6 -4 10 5 10 19 0 22 4 26 30 26
25 0 30 -4 30 -25 0 -14 5 -25 10 -25 6 0 10 27 10 61 0 37 -4 58 -10 54 -5
-3 -10 -15 -10 -26 0 -14 -7 -19 -29 -19 -24 0 -30 5 -33 26 -2 14 -6 22 -10
18z"/>
<path d="M7280 500 l0 -60 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0 -30
5 -30 15 0 10 10 15 31 15 17 0 28 4 24 10 -3 6 -17 10 -31 10 -15 0 -24 6
-24 15 0 10 10 15 30 15 17 0 30 5 30 10 0 6 -18 10 -40 10 l-40 0 0 -60z"/>
<path d="M7430 506 c0 -30 5 -58 10 -61 6 -3 10 3 10 14 0 27 26 27 40 1 17
-32 25 -23 27 32 3 58 -5 68 -54 68 l-33 0 0 -54z m65 14 c0 -8 -10 -16 -22
-18 -18 -3 -23 2 -23 18 0 16 5 21 23 18 12 -2 22 -10 22 -18z"/>
<path d="M7600 500 l0 -60 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0 -30
5 -30 15 0 9 9 15 25 15 33 0 32 18 0 22 -37 4 -35 22 3 26 42 4 31 22 -14 22
l-34 0 0 -60z"/>
<path d="M2598 493 c67 -2 177 -2 245 0 67 1 12 3 -123 3 -135 0 -190 -2 -122
-3z"/>
<path d="M8162 493 c70 -2 187 -2 260 0 73 1 16 3 -127 3 -143 0 -203 -2 -133
-3z"/>
<path d="M5890 438 c0 -19 2 -20 10 -8 13 19 13 30 0 30 -5 0 -10 -10 -10 -22z"/>
<path d="M7750 450 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
